/**
 * 搜索课程(学习项目)
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { ICourseList, LIST_TYPE } from '@umu/umu-types';
import { getQueryString } from '@umu/umu-dom';

export interface IInput {
    page: number;
    size: number;
    category_id?: string;
    keyword?: string;
    sort: LIST_TYPE;
    eid?: string;
    search_id?: string;
    channel?: string;
}
export interface IParam {
    page: number;
    size: number;
    eid?: string;
    keyword?: string;
}
// 搜索课程
export const searchCourse = (data: IInput) => {
    if (data.category_id === '-1') {
        delete data.category_id;
    }

    const eid = getQueryString('eid') || '';
    if (eid) {
        data.eid = eid;
    }
    return fetchData(Api.SEARCH_COURSE, data).then((res: IListResponse<ICourseList>) => {
        return res.data;
    });
};
